<div [formGroup]="candidateForm">
	<div class="grid grid-cols-2 gap-4">
		<!-- Staff Number -->
		<div class="form-element">
			<mat-label for="form-name">Staff Number</mat-label>
			<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
				<input
					type="text"
					formControlName="staffNumber"
					matInput
					placeholder=""
					maxlength="7"
					(focusout)="onFocusOut($event)"
				/>
				@if (staffNumber.errors && !staffNumber.hasError("ownStaffNumber")) {
					<mat-error>
						{{ sharedService.getErrorMessage(staffNumber) }}
					</mat-error>
				}
			</mat-form-field>
			@if (staffNumber.hasError("ownStaffNumber")) {
				<p class="mt-1 text-sm text-red">{{ sharedService.errorMessages.ownStaffNumber }}</p>
			}
		</div>
		<!-- Candidate Name -->
		<div class="form-element">
			<mat-label for="form-name">Name</mat-label>
			<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
				<input type="text" formControlName="name" matInput placeholder="" [readonly]="isOnline" />
				@if (name.errors) {
					<mat-error>
						{{ sharedService.getErrorMessage(name) }}
					</mat-error>
				}
			</mat-form-field>
		</div>
		<!-- Candidate Rank -->
		<app-cbta-autocomplete
			[label]="'Rank'"
			[placeholder]="'Please Select'"
			[data]="rank.value"
			(focusOut)="saveRank($event)"
			[options]="filteredRankOptions"
			[field]="rank"
			[readonly]="false"
		></app-cbta-autocomplete>

		<!-- Pilot Profile -->
		<app-cbta-autocomplete
			[label]="'Trainee Profile'"
			[placeholder]="'Please Select'"
			[data]="pilotProfile.value"
			(focusOut)="savePilotProfile($event)"
			[options]="sharedService.dropDownOptionsPilotProfile"
			[field]="pilotProfile"
		></app-cbta-autocomplete>
		<!-- <div class="form-element">
    <mat-label for="form-name">Pilot Profile</mat-label>
    <mat-form-field appearance="outline" class="w-full mt-1">
      <input
        type="text"
        formControlName="pilotProfile"
        matInput
        
        placeholder=""
        />
    </mat-form-field>
  </div> -->

		<!-- License Number -->
		<div class="form-element">
			<mat-label for="form-name">License Number, ATPL / CPL</mat-label>
			<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
				<input type="text" formControlName="licenseNo" matInput placeholder="" />
				@if (licenseNo.errors) {
					<mat-error>
						{{ sharedService.getErrorMessage(licenseNo) }}
					</mat-error>
				}
			</mat-form-field>
		</div>
		<!--  Training Date -->
		<app-cbta-datepicker
			[datePickerInput]="datePickerInput"
			[inputDesign]="'formType'"
			label="License Expiry Date"
			placeHolder="DD/MM/YY"
			[defaultValue]="licenseExpiryDate.value"
			[minDate]="today"
			[format]="DATE_FORMAT.LICENSE_DATE_FORMAT"
			(selectedDateChange)="handleDateChange($event)"
			(onDatePickerInit)="onDatePickerInit($event)"
		></app-cbta-datepicker>
	</div>

	<div [formGroup]="sessionsDetails" class="p-4 px-6" id="session-checkboxes">
		<p>Please select relevant session. Instructor can select more than ONE(1)</p>
		<div class="mt-5 grid grid-cols-3 gap-4 gap-y-4 lg:grid-cols-4">
			@for (session of sessions; track session; let i = $index) {
				<mat-checkbox
					[checked]="$safeNavigationMigration(sessionsDetails.get(session.code)?.value)"
					[formControlName]="session.code"
					[color]="'primary'"
				>
					{{ session.description }}
				</mat-checkbox>
			}
		</div>
	</div>
</div>
